<script>
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import {ORDER_STATUS} from "../lib/constants";
    import Alert from "../stores/alerts";
    import {formatDate} from "../lib/lib";

    let list = null;
    let total = 0;
    let page = 1;
    let search = {
        limit: 50,
        offset: 0,
        date_from: '',
        date_to: '',
        view: 'assign',
    }

    const pageHeaderControls = [
        {id: 'export', name: 'Εξαγωγή', icon: 'file-excel'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const views = ['assign', 'return', 'destroy'];

    const load = (loader = LOADER.POPUP) => {
        const onSuccess = result => {
            list = result.list;
            total = result.total;
            list.map(item => {
                item.total = (~~item.passport_to - ~~item.passport_from) + 1;
                item.address = setAddressFromMember(item.member);
                item.phone = setPhoneFromMember(item.member);
            })
        }

        const onFailure = err => {
        };

        search.offset = (page - 1) * search.limit;

        R.handle(R.passportReport.index, search, onSuccess, onFailure, loader);
    }

    const setAddressFromMember = (member) => {
        let str = member.address + (member.address ? ", " : "") + member.post_code + (member.post_code ? " " : "") + member.city;
        return str;
    }

    const setPhoneFromMember = (member) => {
        if (member.phone1) return member.phone1;
        if (member.phone2) return member.phone2;
        return member.mobile;
    }

    const onSearch = () => {
        page = 1;
        load();
    }

    const clearSearch = () => {
        search.date_from = '';
        search.date_to = '';
        search.view = 'assign';
        page = 1;
        load();
    }

    const onPageChange = ({detail}) => {
        page = detail;
        load();
    }

    const onExport = () => {

        const onSuccess = result => {
            Alert.alert("Εξαγωγή διαβατηρίων", `Η εξαγωγή ολοκληρώθηκε.\nΑρχείο εξαγωγής:\n<a href="${result.link}" target="_blank">${result.link}</a>`);
        }

        const onFailure = err => {
        };

        if (!list || list.length == 0) {
            Alert.warning("Εξαγωγή διαβατηρίων", "Δεν βρέθηκαν διαβατήρια για εξαγωγή!");
            return;
        }

        R.handle(R.passportReport.export, search, onSuccess, onFailure, LOADER.POPUP);
    }

    load(LOADER.PAGE);
</script>

<PageHeader title="Διαβατήρια" controls={ pageHeaderControls } on:export={ onExport } on:reload={ load }/>

<div class="panel panel-simple pb-2 mb-5">
    <div class="row row-condensed">
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">από</div>
                <input type="date" class="form-control" bind:value={ search.date_from } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-3 col-6 pt-2">
            <div class="form-item">
                <div class="form-item-info top">έως</div>
                <input type="date" class="form-control" bind:value={ search.date_to } on:change={ onSearch }>
            </div>
        </div>
        <div class="column-condensed col-xl-2 col-lg-4 col-md-3 col-6 pt-2">
            <select class="form-select" bind:value="{ search.view }" on:change={ onSearch }>
<!--                <option value="">κατάσταση</option>-->
                <option value="assign">Ανάθεση</option>
                <option value="return">Επιστροφή</option>
                <option value="destroy">Καταστροφή</option>
            </select>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="column-condensed col-xl-1 col-lg-2 col-md-2 col-6 pt-2">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

{#if list}
    {#if list.length}
        <div class="mb-2">
            Σύνολο εγγραφών: <b>{list.length}</b>
        </div>
        <table class="table table-list mb-2">
            <thead>
            <tr>
                <th>Αριθμός</th>
                <th>Συν.</th>
                <th>Μέλος</th>
                <th>ΑΦΜ</th>
                <th>Διεύθυνση</th>
                <th>Τηλέφωνο</th>
                <th>Αρ. Παραγ.</th>
                <th>Ημερομηνία</th>
            </tr>
            </thead>
            <tbody>
            {#each list as item}
                <tr>
                    <td class="passports-column">
                    <span class:not-active="{ item.status_id > ORDER_STATUS.COMPLETED}">
                        GR010{ item.passport_from } - GR010{ item.passport_to }
                    </span>
                    </td>
                    <td class="numeric-column text-gray text-center">{ item.total }</td>
                    <td class="text-gray">{ item.member.lastname } { item.member.firstname }</td>
                    <td class="text-gray">{ item.member.afm }</td>
                    <td class="text-gray">{ item.address }</td>
                    <td class="phone-column text-gray">{ item.phone }</td>
                    <td class="ref-id-column text-gray">{ item.ref_id }</td>
                    <td class="date-column text-gray">{ formatDate(item.created_at, 'd-m-y') }</td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ search.limit }" totalItems="{ total }" { page } on:change="{ onPageChange }"/>
    {:else}
        <div class="panel-simple panel-pad">
            Δεν βρέθηκαν διαβατήρια.
        </div>
    {/if}
{/if}

<style>
    .passports-column {
        width: 220px;
    }

    .phone-column {
        width: 110px;
    }

    .ref-id-column {
        width: 120px;
    }

    .row-condensed {
        margin-left: 5px;
        margin-right: 5px;
    }

    .row-condensed .column-condensed {
        padding-left: 5px;
        padding-right: 5px;
    }
</style>
